import React, { useCallback, useEffect, useState } from "react";
import "../../BookingHistory/customComp/ClubReviewPage.css";
import { FaStar } from "react-icons/fa";
import { HiOutlineArrowLeft } from "react-icons/hi";
import { FiLock } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import Loginpopup from "../../Navbar/Loginmodal";
import ClubReviewForm from "../../BookingHistory/customComp/ClubReviewForm";

export default function VenueClubReview() {

    const navigate = useNavigate();
    const [showLoginPopup, setShowLoginPopup] = useState(false);

    const handleLogin = useCallback((ud) => {
        if (ud) {
            localStorage.setItem("userData", JSON.stringify(ud));
            window.location.reload();
            setShowLoginPopup(false);
        }
    }, []);

    useEffect(() => {
        const userData = localStorage.getItem("userData");
        if (!userData) {
            setShowLoginPopup(true);
        }
    }, []);


    return (
        <>
            {showLoginPopup && <Loginpopup clbk={handleLogin} isbackendUrl={true} />}

            <div className="club-review-review-page">
                {/* Header */}
                <div className="club-review-header">
                    <button onClick={() => navigate(-1)} className="club-review-back-btn"><HiOutlineArrowLeft /></button>
                    <h2>Review</h2>
                </div>

                {/* Rate and Review */}
                <div className="club-review-card">
                    <h3>Rate and Review</h3>
                    <p>We'd love your feedback! Rate your experience with our services.</p>
                </div>

            
                {/* User Review Section */}
                <ClubReviewForm isVenue={true} />

            </div>
        </>
    );
}
